"use client";

import { renderRichTextAsHTML } from "@/components/molecules/Heading";
import { TestimonyBlockProps } from "@/page-builder/fragments/TestimonyBlock/types";
import { InfoBackgroudWrapper } from "../../InfoBackgroudWrapper";

export const TestimonyBlockContent = (data: TestimonyBlockProps) => {
  return (
    <InfoBackgroudWrapper>
        <div className="flex flex-col gap-16 mx-auto">
          <div className="text-xl-regular text-neutral-900 py-8">
            {renderRichTextAsHTML(
              data?.content,
              true,
              "text-neutral-900",
              "md:text-xl-regular text-m-regular"
            )}
          </div>
          <div className="text-l-bold text-primary-500 xl:text-xl-bold">
            {data?.personName}
            <span dangerouslySetInnerHTML={{ __html: "<br>" }} />
            <span className="text-l-bold text-primary-500 xl:text-xl-bold">
              {data?.personRole}
            </span>
          </div>
        </div>
    </InfoBackgroudWrapper>
  );
};
